import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../../utils/date";
import { useGetUsimOrdersUploadJobsQuery } from "../../../../api/usim/orders/UsimOrdersApi";
import { ProductGroupUploadJob } from "../../../../api/product/ProductGroupUploadJob";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "UpdatedAt",
    key: "UpdatedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-",
    sorter: (a: ProductGroupUploadJob, b: ProductGroupUploadJob) => a.ProcessedFinishedAt.localeCompare(b.ProcessedFinishedAt),
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "IngestedRows",
    key: "IngestedRows"
  },
  {
    title: "Error Count",
    dataIndex: "ErrorRows",
    key: "ErrorRows",
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: ProductGroupUploadJob) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }
]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetUsimOrdersUploadJobsQuery();
  const sData = data?.toSorted((a, b) =>
    b.ProcessedFinishedAt.localeCompare(a.ProcessedFinishedAt));
  return (
    <>
      <Button onClick={refetch} type="primary">Reload</Button>
      {error && <Alert type="error" message="Error loading data" />}
      <Table
        loading={isFetching}
        dataSource={sData}
        columns={columns}
      />
    </>
  )
}